export default __webpack_public_path__ + "static/media/tituloGaleria.11647775.png";